import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export const ENTITY_SELECT_ADD_NEW = 'add-new';

export interface EntitySelectProps<T> {
  items: T[];
  value: string;
  onValueChange: (value: string) => void;
  getItemValue: (item: T) => string;
  renderItem: (item: T) => ReactNode;
  placeholder?: string;
  disabled?: boolean;
  addNewLabel?: string;
  onAddNew?: () => void;
  triggerClassName?: string;
  id?: string;
}

export function EntitySelect<T>({
  items,
  value,
  onValueChange,
  getItemValue,
  renderItem,
  placeholder,
  disabled,
  addNewLabel,
  onAddNew,
  triggerClassName,
  id,
}: EntitySelectProps<T>) {
  const handleChange = (next: string) => {
    if (next === ENTITY_SELECT_ADD_NEW) {
      onAddNew?.();
      return;
    }
    onValueChange(next);
  };

  return (
    <Select onValueChange={handleChange} value={value} disabled={disabled}>
      <SelectTrigger id={id} className={triggerClassName}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {items.map((item) => (
          <SelectItem key={getItemValue(item)} value={getItemValue(item)}>
            {renderItem(item)}
          </SelectItem>
        ))}
        {onAddNew && addNewLabel ? (
          <SelectItem value={ENTITY_SELECT_ADD_NEW} className={cn('text-fin-accent font-medium')}>
            + {addNewLabel}
          </SelectItem>
        ) : null}
      </SelectContent>
    </Select>
  );
}
